import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
 import { DelegationComponent } from './delegation/delegation.component';
import { LogoutComponent } from './logout/logout.component';
import { MenubarComponent } from './menubar/menubar.component';

import { AuthGuard } from './utility/app.guard';
import { ErrorHandlerComponent } from './error-handler/error-handler/error-handler.component';
import { AdministrationComponent } from './administration/administration.component';
import { RouterComponent } from './router/router.component';
import { CanDeactivateGuard } from './utility/can-exit.guard';
import { ReportsComponent } from './reports/reports.component';

const routes: Routes = [
  {
    path: 'error/:error',
    component: ErrorHandlerComponent,
  },
  {
    path: 'delegation',
    component: DelegationComponent,
    canActivate: [AuthGuard],
    canDeactivate:[CanDeactivateGuard] 
  },
  {
    path: 'routes',
    component: RouterComponent,
    canActivate: [AuthGuard],
    canDeactivate:[CanDeactivateGuard] 
  },
  {
    path: 'administration',
    component: AdministrationComponent,
    canActivate: [AuthGuard],
    canDeactivate:[CanDeactivateGuard] 
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    canDeactivate:[CanDeactivateGuard] 
  },
  { path: 'menu', component: MenubarComponent, canActivate: [AuthGuard] },  
  { path: 'logout', component: LogoutComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
